import { auth } from "../firebase";

const UNITY_TEST_FAKE_TOKEN = "fakeToken_for_unity_testing";

const normalizeSseToken = (token?: string | null): string | null => {
  if (!token || token === UNITY_TEST_FAKE_TOKEN) return null;
  return token;
};

export const resolveSseToken = async (
  providedToken?: string | null,
): Promise<string | null> => {
  if (auth.currentUser) {
    try {
      const token = await auth.currentUser.getIdToken(true);
      const normalizedToken = normalizeSseToken(token);
      if (normalizedToken) {
        localStorage.setItem("firebaseToken", normalizedToken);
        sessionStorage.setItem("firebaseToken", normalizedToken);
      }
      return normalizedToken;
    } catch (error) {
      if (process.env.NODE_ENV === "development") {
        const message = error instanceof Error ? error.message : "Unknown error";
        console.warn("[SSE] Firebase token refresh failed.", { message });
      }
      return null;
    }
  }

  return normalizeSseToken(
    providedToken ||
      localStorage.getItem("firebaseToken") ||
      sessionStorage.getItem("firebaseToken"),
  );
};
